<template>
    <div>
        <forms
            :settings="settings"
            @onFormButtonClick="onFormButtonClick"
            @onInput="onInput"
        >
        </forms>
    </div>
</template>

<script>
import axios from "axios";
import toastr from 'toastr';
import Forms from "@/components/form/Forms";
export default {
    name: "SkupSuorganizatorForma",
    components: { Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/skupovi/' + this.$route.params.skup_id + '/suorganizatori',
            url: 'skup-suorganizator',
            data: {},
            skup: {},
            skup_id: this.$route.params.skup_id,

            vrsta_suorganizatora_select: [],
        }
    },

    methods: {

        async fetchSkup(){
            let vm = this
            await axios.get( process.env.VUE_APP_API_URL + 'skup' + '/' + this.skup_id )
                .then( response => vm.skup = response.data )
                .catch( error => console.log( error ) )
        },

        async fetchVrsteSuorganizatora(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'vrsta-suorganizatora', {
                params: {
                    filters: {
                        izzy_edu_vrsta_suorganizatora: vm.skup.izzy_edu_id
                    }
                }
            } )
            return response.data.data.map( function( item ) {
                vm.vrsta_suorganizatora_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getVrstaSuorganizatora( id ){
            return this.vrsta_suorganizatora_select.find( item => item.key === id )
        },



        async init(){
            let vm = this

            await vm.fetchSkup()
            await vm.fetchVrsteSuorganizatora()

            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                    .then( function ( response ) {

                        vm.data.naziv = response.data.naziv
                        vm.data.vrsta_suorganizatora_id = response.data.vrsta_suorganizatora_id ? response.data.vrsta_suorganizatora_id.toString() : ''

                        vm.$emit( 'returnData', response.data )
                        vm.setupForm()
                    } )
                    .catch( function ( error ) {
                        if(error instanceof Error) {
                            console.log( 'Error: ' . error);
                        } else {
                            console.log( 'Unexpected response: ' . error);
                        }
                    } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.setupForm()
            } else {
                return
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }

            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: [
                                    {
                                        name: 'skup_id',
                                        type: 'hidden',
                                        value: vm.skup_id,
                                        disabled: vm.disabled,
                                        config: {
                                            hidden:true
                                        }
                                    },
                                    {
                                        name: 'naziv',
                                        type: 'input',
                                        title: 'Naziv',
                                        value: vm.data['naziv'] ? vm.data['naziv'] : '',
                                        width: 12,
                                        error: vm.errors['naziv'] ? vm.errors['naziv'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled || vm.action === 'edit',
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                    },
                                    {
                                        name: 'vrsta_suorganizatora_id',
                                        type: 'select',
                                        title: 'Vrste uorganizatora',
                                        value: vm.getVrstaSuorganizatora( vm.data.vrsta_suorganizatora_id ),
                                        width: 12,
                                        error: vm.errors['vrsta_suorganizatora_id'] ? vm.errors['vrsta_suorganizatora_id'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            options: vm.vrsta_suorganizatora_select,
                                            multiple: false,
                                        }
                                    },
                                ],
                            }
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },

        /**
         *  on input return data
         */
        onInput( name, value ){
            let vm = this
            if( vm.data[name] !== value ){
                vm.data[name] = value
                vm.setupForm()
            }
        },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.setupForm()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>
